import { combineReducers } from "redux";
import { userReducer } from "./userReducer";
import { bookReducer } from "./bookReducer";

export const rootReducer = combineReducers({
  user: userReducer,
  book: bookReducer
});
